export default "dist/images/components-button-controls-link.0f2d52b.png";